/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RejectTradingChallengeRegistrationRequestOptions,
  RejectTradingChallengeRegistrationRequestResponses,
} from '../types/RejectTradingChallengeRegistrationRequest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Accessible to admins (any challenge), integrators (their own tenant only) and competition managers (their assigned challenges only).
 * @summary Reject a trading challenge registration request
 * {@link /v1/trading_challenges/registration_requests/:request_id/reject}
 */
export function rejectTradingChallengeRegistrationRequest<ThrowOnError extends boolean = true>(
  options: Options<RejectTradingChallengeRegistrationRequestOptions, ThrowOnError>,
): Unwrappable<RequestResult<RejectTradingChallengeRegistrationRequestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges/registration_requests/{request_id}/reject',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RejectTradingChallengeRegistrationRequestResponses, ThrowOnError>>,
  )
}
